// components/ui/GlowingCard.jsx
import React from 'react';

const GlowingCard = ({ 
  children, 
  className = "",
  glowColor = "from-blue-600/10 via-purple-600/10 to-violet-600/10",
  glowIntensity = "blur-xl",
  cardOpacity = "bg-[#1a1f2d]/90"
}) => {
  return (
    <div className="relative w-full">
      {/* Background Effects - Subtle Glow */}
      <div className={`absolute inset-0 bg-gradient-to-r ${glowColor} rounded-xl ${glowIntensity}`}></div>
      
      {/* Content Container with Backdrop Blur */}
      <div className={`relative ${cardOpacity} backdrop-blur-sm rounded-xl border border-white/5 shadow-xl ${className}`}>
        {children}
      </div>
    </div>
  );
};

export default GlowingCard;